import { lumaBotFlowTemplateBaseModel } from './crud';

export * from './types';

export const useLumaBotFlowTemplateByIdV2 =
  lumaBotFlowTemplateBaseModel.fetchByIdV2();
export const useLumaBotFlowTemplateByIdsV2 =
  lumaBotFlowTemplateBaseModel.fetchByIdsV2();
export const useLumaBotFlowTemplateManyV2 =
  lumaBotFlowTemplateBaseModel.fetchManyV2();
export const useLumaBotFlowTemplateManyByContentRangeV2 =
  lumaBotFlowTemplateBaseModel.fetchManyByContentRangeV2();
export const useLumaBotFlowTemplateCountV2 =
  lumaBotFlowTemplateBaseModel.countV2();
export const useLumaBotFlowTemplatePaginationV2 =
  lumaBotFlowTemplateBaseModel.fetchPaginatedV2();
export const useLumaBotFlowTemplateUpdateOneV2 =
  lumaBotFlowTemplateBaseModel.editV2();
export const useLumaBotFlowTemplateCreateOneV2 =
  lumaBotFlowTemplateBaseModel.createV2();
export const useLumaBotFlowTemplateRemoveOneV2 =
  lumaBotFlowTemplateBaseModel.deleteV2();
export const useLumaBotFlowTemplateRemoveByIdsV2 =
  lumaBotFlowTemplateBaseModel.deleteByIdsV2();
